<div class="credit-flows">
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <mat-form-field class="search">
          <input matInput type="text" [readonly]="loader.tableLoading.inProgress$ | async" placeholder="Search cron job..." [formControl]="formControlSearch">
          <span class="mdi mdi-magnify" matPrefix></span>
        </mat-form-field>
      </div>
      
    </div>
    
  
 

    <div class="row">
        <div class="col-12">
            @if (loader.tableLoading.inProgress$ | async) {
                <custom-content-loader type="list"></custom-content-loader>
            }
            
            <!-- Accordion View -->
           
              <div [ngClass]="{hidden: (loader.tableLoading.inProgress$ | async)}">
                <mat-accordion multi="true" class="mt-3">
                  @for (category of getCategorizedJobs(); track category) {
                    <mat-expansion-panel [expanded]="true">
                      <mat-expansion-panel-header>
                        <div fxLayout="row" fxLayoutAlign="start center" class="supplier-name">
                          <div>
                            <span class="title">{{category}}</span>
                            <span class="ml-2 text-muted">({{getJobsForCategory(category).length}} jobs)</span>
                          </div>
                        </div>
                      </mat-expansion-panel-header>
                      
                      <div class="accordion-content">
                        <table mat-table [dataSource]="getJobsForCategory(category)" multiTemplateDataRows class="width-100 mb-2" [trackBy]="trackByFn">
                          <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef>ID</th>
                            <td mat-cell *matCellDef="let element" class="td-width ellipsis">{{element.id}}</td>
                          </ng-container>

                          <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>Name</th>
                            <td mat-cell *matCellDef="let element" class="td-width ellipsis" [matTooltip]="element.name || '-'"
                            [matTooltipDisabled]="!element.name || element.name.length <= 20">
                            {{element.name || '-'}}
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="route">
                            <th mat-header-cell *matHeaderCellDef>Route</th>
                            <td mat-cell *matCellDef="let element" class="td-width ellipsis" [matTooltip]="element.route || '-'"
                            [matTooltipDisabled]="!element.route || element.route.length <= 20">
                            {{element.route || '-'}}
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="createdTime">
                            <th mat-header-cell *matHeaderCellDef>Created Time</th>
                            <td mat-cell *matCellDef="let element" class="">
                              {{moment(element.createdTime).format('DD/MM/YYYY HH:mm:ss')}}
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element" class="td-width ellipsis">
                              <div fxLayout="row wrap"
                              fxLayoutAlign="start center"
                              fxLayout.lt-md="column"
                              fxLayoutAlign.lt-md="center center">
                                <span class="mdi mdi-play-circle-outline cursor-pointer icon-margin date-text" 
                                      matTooltip="Run this cron job" 
                                      (click)="runCronJob(element.route)"></span>
                              </div>
                            </td>
                          </ng-container>
                          
                          <ng-container matColumnDef="expandedDetail">
                            <td mat-cell *matCellDef="let element;" class="expanded-row" [attr.colspan]="columnsToDisplay.length">
                              <div class="example-element-detail"
                                [@detailExpand]="element.id === expandedElementIds[category] ? 'expanded' : 'collapsed'">
                                
                                @if (element.description) {
                                  <div class="row mt-3">
                                    <div class="col-3 title">Description</div>
                                    <div class="col-9">{{element.description}}</div>
                                  </div>
                                }
                             
                                <div class="row mt-3">
                                  <div class="col-3 title">Last Success Instance ID</div>
                                  <div class="col-9">{{element.lastSuccessInstanceId_D}}</div>
                                </div>
                                
                                <div class="row mt-3 mb-5">
                                  <div class="col-3 title">Last Failure Instance ID</div>
                                  <div class="col-9">{{element.lastFailureInstanceId_D}}</div>
                                </div>
                              </div>
                            </td>
                          </ng-container>
                    
                          <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                          <tr mat-row *matRowDef="let element; columns: columnsToDisplay" class="example-element-row"
                            [class.example-expanded-row]="element.id === expandedElementIds[category]"
                            (click)="onRowClick(element, category)"></tr>
                          <tr class="example-detail-row"
                              [ngClass]="{'example-detail-row-expanded': isRowExpanded(row.id, category)}"
                              [ngStyle]="isRowExpanded(row.id, category) ? {} : {'display': 'none'}"
                              mat-row
                              *matRowDef="let row; columns: ['expandedDetail']"></tr>
                        </table>
                      </div>
                    </mat-expansion-panel>
                  }
                </mat-accordion>
              </div>
            
        </div>
    </div>
</div>
